import { useEffect } from 'react';
import { VALID_GAME_ID } from '@root/constants';
import { useActions, useGetGameHistoryQuery } from '@root/store/store';

export function useRoundHistoryInit() {
  const { data: gameHistory } = useGetGameHistoryQuery(VALID_GAME_ID);
  const { setRoundHistory } = useActions();

  useEffect(() => {
    const history =
      gameHistory?.data?.roundResults
        ?.filter((result) => !result.cancelled && result.winner)
        .map((result) => result.winner) ?? [];

    if (history.length > 0) {
      setRoundHistory(history);
    }
  }, [gameHistory, setRoundHistory]);
}
